
export default {
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isRightAligned() {
      return this.slice.primary.image_location === 'right'
    },
  },
}
